// @codekit-prepend "../plugins/jquery.bxslider.js"
// @codekit-prepend "../plugins/jquery.styledSelect.js"
// @codekit-prepend "../plugins/jquery.overlayScrollbars.js"

( function($) {

    $(document).ready(function(){

        //Bind Mobile Menu Triggers
        bindMobileMenu();

        //Bind Header Top Menu Buttons
        bindFayTopMenu();

        //Bind Anything that needs to resize after load
        bindFaySizing();

        //Bind Top Slider
        bindFayTopSlider();

        //Bind Button Effects
        bindFayButtonEffects();

        //Bind Styled Select
        bindStyledSelect();

        //Bind Tabbed Content
        bindTabbedContent();

        //Bind forgot password link
        bindMoveForgotPassword();
        //Bind Page Content
        bindPageContentFunctions();

        //Bind FAQ Dropdowns
        bindFayFAQs();

        //Bind Attractions Listings Block
        bindAttractionListingsBlock();

        //Position Image Caption
        positionImageCaptions();

    });

    $(window).on('resize', function(){

        //Bind Header Needs
        bindFaySizing();

        //Position Image Caption
        positionImageCaptions();

    });

    function positionImageCaptions(){
        $('.image--caption, figcaption').each(function(){
            $(this).show();
            var img = $(this).prev('img');
            if($(this).parent().hasClass('background')){
                $(this).css({
                    right: 10,
                    bottom: 10
                });
            } else {
                var ip = img.position();
                var h = (ip.top + img.height()) - ($(this).height() + 10);
                var w = (ip.left + img.width()) - ($(this).width() + 10);
                $(this).css({
                    top: h + 'px',
                    left: w + 'px'
                });
            }
        });
    }

    function bindMobileMenu(){
        $('.mobile-menu-trigger').on('click', function(){
            $('#mobile-menu').addClass('active');
        });
        $('.mobile-menu-close').on('click', function(){
            $('#mobile-menu').removeClass('active');
        });
        $('#mobile-menu ul.menu > li > a').on('click', function(e){
            e.preventDefault();
            $(this).parent().trigger('click');
            return false;
        });
        $('#mobile-menu ul.menu > li').on('click', function(e){
            e.preventDefault();
            if($(this).hasClass('active')){
                $(this).removeClass('active');
                $(this).find('ul').slideUp();
            } else {
                $('#mobile-menu ul.menu > li.active > ul').slideUp();
                $('#mobile-menu ul.menu > li').removeClass('active');
                $(this).find('ul').slideDown();
                $(this).addClass('active');
            }
            return false;
        });
        $('#mobile-menu ul.menu > li > ul.sub-menu a').on('click', function(e){
            e.preventDefault();
            var href = $(this).attr('href');
            window.location = href;
            return false;
        });
    }

    function bindFayTopMenu(){
        $('#menu-top-menu > li > a').on('click', function(e){
            e.preventDefault();
            return false;
        });

        $(window).on('scroll', function(){
            if($(window).scrollTop() > 46 && $(window).width() <= 600){
                $('header, #mobile-menu').addClass('scrolleddown');
            } else {
                $('header, #mobile-menu').removeClass('scrolleddown');
            }
        });
    }

    function bindFaySizing(){
        $('.header-holder').height($('header').height());
        bindMakeSquare()
    }

    function bindFayTopSlider(){
        $('.slider').bxSlider({
            pager: false,
            auto: true,
            stopAutoOnClick: true,
            autoHover: true,
        });
    }

    function bindFayButtonEffects(){
        $('.btn').each(function(){
            var con = $(this).html();
            $(this).html('');
            $(this).append('<span class="btn-content">'+con+'</span>');
        });
    }

    function bindTabbedContent(){
        $('.tabbed-trigger').on('click', function(e){
            e.preventDefault();
            if(!$(this).hasClass('active')){
                $('.tabbed-trigger, .tabbed-panel').removeClass('active');
                $(this).addClass('active');
                var ref = $(this).attr('tab-ref');
                $('.tabbed-panel[tab-id="'+ref+'"]').addClass('active');
                if($(window).width() < 500){
                    var off = $(this).closest('.tabbed-content').find('.tabbed-panels').offset();
                    $('html, body').animate({scrollTop: off.top - 180 });
                }
            }
            return false;
        });

        //When a nav item is clicked
        $('.page-nav-menu .nav-item').on('click', function(){
            if(!$(this).hasClass('active') && !$('body').hasClass('home')){
                var page = $(this).attr('data-page');
                $(this).parent().find('.nav-item').removeClass('active');
                $(this).addClass('active');
                $('.page-panel').removeClass('display--block').addClass('display--none');
                $('#' + page).addClass('display--block').removeClass('display--none');
                setTimeout(function(){ bindMakeSquare(); }, 20);
            }
        });
    }

    function bindPageContentFunctions(){

        //Page functions minutes
        $('[href="#drop-archive-meeting-minutes"]').on('click', function(e){
            e.preventDefault();
            var archive = $(this).closest('.meetings-archive').find('.archived');
            if(archive.hasClass('showing')){
                archive.slideUp();
                archive.removeClass('showing');
                $(this).find('i').removeClass('icon-chevron-up');
                $(this).find('i').addClass('icon-chevron-down');
            } else {
                archive.slideDown();
                archive.addClass('showing');
                $(this).find('i').addClass('icon-chevron-up');
                $(this).find('i').removeClass('icon-chevron-down');
            }
        });

    }

    function bindFayFAQs(){

        //Dropdowns on FAQs
        $(".faq .question").off('click');
        $(".faq .question").on('click', function(){

            if($(this).hasClass('open')){
                $(this).removeClass('open');
                $(this).parent().find('.answer').slideUp("fast");
            } else {
                $(this).addClass('open');
                $(this).parent().find('.answer').slideDown("fast");
            }

        });

    }

    function bindAttractionListingsBlock(){
        $('.attraction-listings-type-switcher').on('style-select:select', function(){
            window.location.href = $(this).val();
        });
    }

})( jQuery );

function bindMakeSquare(){
    jQuery('.make-square').each(function(){
        jQuery(this).height(jQuery(this).width());
    });
}

function bindMoveForgotPassword(){
    jQuery('.gf_login_links br').remove();
    var html = jQuery('.gf_login_links').first().html();
    jQuery('.gf_login_links').remove();
    jQuery('.gform_login_widget #input_3').append(html);
    jQuery('.gform_login_widget #input_3').addClass('flex flex--between flex--middle');
    jQuery('.gform_login_widget #input_3 label').html('Keep&nbsp;me&nbsp;signed&nbsp;in');
}
